export const DeliveryListHeadOfficePage = () => {
  return <></>;
};
